<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>档口收包记录</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-select
                    v-model="form.city"
                    placeholder="城市"
                    multiple
                    @change="cityChange"
                  >
                    <el-option
                      v-for="item in resData.market_option"
                      :key="item.city_index"
                      :label="item.city"
                      :value="item.city_index"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="市场">
                  <el-select
                    v-model="form.market_id"
                    filterable
                    placeholder="市场"
                    @change="marketChange"
                  >
                    <el-option label="全部" :value="0"></el-option>
                    <el-option
                      v-for="item in market"
                      :key="item.market_id"
                      :label="item.market_name"
                      :value="item.market_id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.package_no"
                    placeholder="包裹号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.packge_status"
                    filterable
                    placeholder="包裹状态"
                  >
                    <el-option
                      v-for="item in ConstEnum.packageOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.pici_is_da_biao"
                    filterable
                    placeholder="是否已点货"
                  >
                    <el-option
                      v-for="item in is_da_biao"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pgid"
                    multiple
                    filterable
                    placeholder="代采组"
                  >
                    <el-option
                      v-for="item in resData.pglist"
                      :key="item.pgid"
                      :label="item.pgname"
                      :value="item.pgid"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pgm_ids"
                    multiple
                    filterable
                    placeholder="代采员"
                  >
                    <el-option
                      v-for="item in resData.pg_member_option"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.pici_no"
                    placeholder="批次单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.is_chayi"
                    filterable
                    placeholder="是否有差异"
                  >
                    <el-option
                      v-for="item in is_chayi"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.yc_admin_name"
                    placeholder="异常处理人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.yc_status"
                    filterable
                    placeholder="异常状态"
                  >
                    <el-option
                      v-for="item in yc_status"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-cascader
                    v-model="form.receiving_site"
                    placeholder="包裹生成地点"
                    :options="resData.package_option"
                    :props="{ multiple: true }"
                    filterable
                  ></el-cascader>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.package_type"
                    filterable
                    placeholder="包裹类型"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="大货" value="1"></el-option>
                    <el-option label="备货" value="2"></el-option>
                    <el-option label="前置仓" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.db_source"
                    filterable
                    placeholder="打标来源"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="一手收包人员" value="1"></el-option>
                    <el-option label="档口送包人员" value="2"></el-option>
                    <el-option label="异地档口送包" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.stock_storehouse_id"
                    filterable
                    placeholder="接收仓库"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                      v-for="item in resData.stock_storehouse_option"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.is_pre_qc"
                    placeholder="是否质检任务"
                  >
                    <el-option
                      v-for="item in ConstEnum.preQcOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.licence_plate_no"
                    placeholder="车牌号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.invoice_no"
                    placeholder="爆版发货单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.shipping_num"
                    placeholder="快递运单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <br />
                <el-form-item label="包裹生成时间：">
                  <el-date-picker
                    v-model="form.package_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="收包结束时间：">
                  <el-date-picker
                    v-model="form.end_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="仓库接收：">
                  <el-date-picker
                    v-model="form.storage_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="提交点货：">
                  <el-date-picker
                    v-model="form.pici_commit_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="批次创建：">
                  <el-date-picker
                    v-model="form.pici_create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="包裹装车时间：">
                  <el-date-picker
                    v-model="form.loading_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 50px;
            padding: 0 25px;
            text-align: right;
          "
        >
          <el-button
            style="background: #85ce61"
            type="success"
            size="small"
            @click="output(1)"
            >导出收包记录列表</el-button
          >
          <el-button
            style="background: #85ce61"
            type="success"
            size="small"
            @click="output(0)"
            >导出收包记录明细</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table v-if="resData" :data="resData.list">
            <el-table-column
              align="center"
              prop="supply_city"
              label="城市"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="market_name"
              label="市场"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pgname"
              label="代采组"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pg_member_name"
              label="代采员"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_name"
              label="商家"
            ></el-table-column>
            <el-table-column align="center" label="包裹商品数">
              <template slot-scope="scope">
                {{
                  scope.row.is_unknown_package == 2
                    ? "数量不明"
                    : scope.row.goods_num
                }}
              </template>
            </el-table-column>
            <el-table-column prop="package_no" label="包裹号" align="center">
              <template slot-scope="scope">
                <a
                  :href="
                    '#/home/storage/tallying?package_no=' + scope.row.package_no
                  "
                  target="_blank"
                  class="buttonText"
                  >{{ scope.row.package_no }}</a
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="package_type"
              label="包裹类型"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="db_source" label="打标来源" align="center">
            </el-table-column>
            <el-table-column
              align="center"
              prop="package_status_text"
              label="包裹状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="invoice_no_text"
              label="爆版发货单"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="shipping_num"
              label="快递运单号"
            ></el-table-column>
            <el-table-column align="center" prop="pre_qc_text" label="是否质检">
              <template slot-scope="{ row }">
                <el-button
                  v-if="row.qc_task_id"
                  type="text"
                  @click="handleNavQcDetail(row)"
                >
                  是
                </el-button>
                <span v-else>{{ row.pre_qc_text }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="supply_package_record_receiving_site"
              label="包裹生成地点"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="包裹生成时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="end_time"
              label="收包结束时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="truck_loading_time"
              label="包裹装车时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="licence_plate_no"
              label="车牌号"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="storage_admin"
              label="仓库接收人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="storehouse"
              label="接收仓库"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="has_wo"
              label="接收是否已核单"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="first_order_time"
              label="首次核单时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="storage_time"
              label="仓库接收时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pici_create_time"
              width="180"
              label="批次创建时间"
            >
              <template slot-scope="scope">
                <span
                  v-for="(create_time, create_time_key) in scope.row
                    .pici_create_time"
                  :key="create_time_key"
                  style="width: 160px; margin: 0; cursor: pointer"
                >
                  {{ create_time }}<br />
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="pici_no"
              label="批次号"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  v-for="(pici_no_value, pici_no_key) in scope.row.pici_no"
                  :key="pici_no_key"
                  style="width: 160px; margin: 0; cursor: pointer"
                >
                  {{ pici_no_value }}<br />
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="allot_workbench_time"
              label="包裹分配时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="workbench"
              label="分配工作台"
            ></el-table-column>
            <el-table-column
              prop="pici_goods_num"
              label="点货数量"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  v-for="(pici_goods_num_value, pici_goods_num_key) in scope.row
                    .pici_goods_num"
                  :key="pici_goods_num_key"
                  style="width: 160px; margin: 0; cursor: pointer"
                >
                  {{ pici_goods_num_value }}<br />
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="chayi_num"
              label="差异"
            ></el-table-column>
            <el-table-column
              prop="admin_name"
              label="点货人"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  v-for="(admin_name_value, admin_name_key) in scope.row
                    .admin_name"
                  :key="admin_name_key"
                  style="width: 160px; margin: 0; cursor: pointer"
                >
                  {{ admin_name_value }}<br />
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="order_sn"
              label="点货提交时间"
              width="180"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  v-for="(commit_time_value, commit_time_key) in scope.row
                    .commit_time"
                  :key="commit_time_key"
                  style="width: 160px; margin: 0; cursor: pointer"
                >
                  {{ commit_time_value }}<br />
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="package_dabiao_status_txt"
              label="包裹点货状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="yc_admin_name"
              label="处理人"
            ></el-table-column>
            <el-table-column label="操作" show-overflow-tooltip align="center">
              <template slot-scope="scope">
                <div>
                  <el-button
                    type="text"
                    size="small"
                    @click="handleClick(scope.row)"
                    >查看</el-button
                  >
                </div>
                <div>
                  <el-button
                    type="text"
                    size="small"
                    @click="getLog(scope.row)"
                  >
                    扫描日志</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="form.page"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <!-- 扫描日志 -->
    <el-dialog
      :close-on-click-modal="false"
      title="扫描日志"
      :visible.sync="log.show"
      width="600px"
    >
      <el-table :data="log.list">
        <el-table-column prop="operator_name" label="操作人"></el-table-column>
        <el-table-column prop="create_date" label="操作时间"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

const ConstEnum = {
  packageOptions: [
    { label: "全部", value: "0" },
    { label: "待接收", value: "1" },
    { label: "已接收", value: "2" },
    { label: "已点货", value: "3" },
    { label: "已作废", value: "4" },
    { label: "待质检", value: "5" },
  ],
  preQcOptions: [
    { label: "全部", value: "0" },
    { label: "是", value: "1" },
    { label: "否", value: "2" },
  ],
};
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      ConstEnum,
      logData: [],
      logVisible: false,
      resData: {},
      market: [],
      form: {
        city: "",
        market_id: 0,
        page: 1,
        package_time: this.defaultDate(),
        packge_status: "",
        db_source: "",
        is_pre_qc: "", // 是否质检任务
        receiving_site: [],
        address_id: [],
        licence_plate_no: "",
        shipping_num: "",
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Supply/supplyPackageList",
      curPage: 1,
      filterFold: false,
      sub_market: [],
      is_package_status: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      is_da_biao: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      is_chayi: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      receiving_site: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "市场",
        },
        {
          value: "2",
          label: "仓库",
        },
      ],
      yc_status: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "正常",
        },
        {
          value: "2",
          label: "异常待处理",
        },
        {
          value: "3",
          label: "异常已处理",
        },
      ],

      log: {
        show: false,
        list: [],
      },
    };
  },
  computed: {
    filteredForm() {
      const { form } = this;
      Object.keys(form).forEach((key) => {
        if (form[key] === undefined || form[key] === "" || form[key] === null) {
          delete form[key];
        }
      });
      form.address_id = form.receiving_site.map((arr) => arr.join(","));
      return form;
    },
  },
  created() {
    const { pg_group_id: pgGroupId, city, date } = this.$route.query;
    this.form.pgid = pgGroupId?.split(",")?.filter(Boolean);
    this.form.city = city?.split(",")?.filter(Boolean);
    if (date) {
      this.form.package_time = [`${date} 00:00:00`, `${date} 23:59:59`];
    }
  },
  methods: {
    output(hasHd) {
      this.form.is_excel = 1;
      this.form.has_hd = hasHd;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchData() {
      const { pici } = this.$route.query;
      if (pici) {
        this.filteredForm.pici_no = pici;
      }
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          return;
        }
        this.resData = res.data.data;
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      Object.keys(val).forEach((key) => {
        multipleSelection[key] = {
          id: val[key].id,
        };
      });
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.fetchData();
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    cityChange(val) {
      this.market = [];
      this.form.market_id = 0;
      if (val == "") {
        return;
      }
      this.resData.market_option.forEach((v) => {
        if (val == v.city_index) {
          this.market = v.market;
        }
      });
    },
    marketChange(val) {
      this.form.market_id = val;
    },
    SubmarketChange(val) {
      const url = "/erp/Common/getSubMarketList";
      this.$http.post(url, { parent_id: val }).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.sub_market = res.data.data;
        }
      });
    },
    handleClick(row) {
      const { package_record_id: packageRecordId } = row;
      this.$router.push(`/home/supply/packagedetail/${packageRecordId}`);
    },
    defaultDate() {
      const defaultSerachData = 7; // 默认查询的时间天数
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - defaultSerachData);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    getLog(row) {
      this.log.list = [];
      this.$post("/erp/Supply/supplyPackageLog", {
        package_record_id: row.package_record_id,
      }).then((data) => {
        this.log.show = true;
        this.log.list = data.list;
      });
    },
    handleNavQcDetail(row) {
      this.$router.push({
        name: "PreQcDetail",
        query: {
          taskId: row.qc_task_id,
        },
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/SupplyPackageList.vue